export const APIConstant = {
    auth: {
        login: '/tech-team-signin',
        registration: '/tech-team-signup',
        forgotPassword: '/tech-team-forgot-password',
        verifyEmail: '/tech-team-email-validate',
        setNewPassWord: '/set-password',
        refreshToken: '/admin/v1/auth/refresh_token',
        accessPermission: '/permission-list',
        adminLogin: '/app/v1/auth/get-admin-access-token',
    },
    owner: {
        getOwnerList: '/admin/v1/owner/get-all-owners'
    },
    pilot:{
        getPilotList: '/admin/v1/pilot/get-all-pilots'
    },
    profile: {
        getProfileDetails: '/tech-team-get-profile',
        editProfileDetails: '/tech-team-edit-profile',
    },
    user: {
        getUsersList: '/tech-team-get-user-list',
        addUser: '/tech-team-create-profile',
        editUser: '/tech-team-edit-profile',
        deleteUser: '/tech-team-delete-user'
    },
    accessGroup: {
        permissionList: '/permission-list',
        addPermission: '/permission-given-to-group',
        editPermission: '/update-permission-given-to-group',
        accessGroupList: '/access-group-list',
        deleteAccessGroup: '/delete-access-group'
    },
    coupon: {
        getCouponList: '/tech-team-get-coupon-list',
        addCoupon: '/tech-team-create-coupon',
        editCoupon: '/tech-team-edit-coupon',
        deleteCoupon: '/tech-team-delete-coupon'
    }
}